import { render, staticRenderFns } from "./PathwayViewUserInfoCard.vue?vue&type=template&id=a458c592&"
import script from "./PathwayViewUserInfoCard.vue?vue&type=script&lang=js&"
export * from "./PathwayViewUserInfoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports